import { getBoardId } from '@/core/web-storage/webStorage.utils';
import { baseAppApi } from '@/core/network/baseAppApi';
import { COMMON_HEADERS } from '@/core/network/network.constants';
import { getFirstErrorOrDefault } from '@/core/network/network.utils';
import tokens from '@/nav/tokens.json';
import employerRefTokens from '@/employer-ref/tokens.json';

export interface EmployerRefInfoResponse {
  boardNumber: string;
  city: string;
  contactName: string;
  contactPhone: string;
  defaultAtalocalNum: string;
  emailAddress: string;
  employerName: string;
  faxNumber: string;
  mailingCity: string;
  mailingEmail: string;
  mailingFaxNumber: string;
  mailingPhoneNumber: string;
  mailingPostalCode: string;
  mailingProvince: string;
  mailingStreetAddress: string;
  mailingStreetAddressLine2: string;
  payoutAllocation: string;
  pensionPlan: string;
  phoneNumber: string;
  postalCode: string;
  province: string;
  streetAddress: string;
  streetAddressLine2: string;
}

export type UpdateEmployerRefInfoRequestPayloadType = {
  employerName: string;
  payoutAllocation: string;
  defaultAtalocalNum: string;
  pensionPlan: string;
  phoneNumber: string;
  faxNumber: string;
  postalCode: string;
  province: string;
  city: string;
  streetAddress: string;
  streetAddressLine2: string;
  contactName: string;
  contactPhone: string;
  emailAddress: string;
  mailingPostalCode: string;
  mailingProvince: string;
  mailingCity: string;
  mailingStreetAddress: string;
  mailingStreetAddressLine2: string;
  mailingPhoneNumber: string;
  mailingFaxNumber: string;
  mailingEmail: string;
};

export type UpdateEmployerRefInfoRequestType = {
  requestBody: UpdateEmployerRefInfoRequestPayloadType;
};

const employerRefApi = baseAppApi.injectEndpoints({
  endpoints: (build) => ({
    getAllEmployerRefInfo: build.query<EmployerRefInfoResponse[], void>({
      query() {
        return {
          url: `v1/employers/info`,
          method: 'GET',
          headers: COMMON_HEADERS,
        };
      },
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, tokens['EMPLOYER_REFERENCE_NOT_FOUND_TRY_AGAIN']);
      },
    }),
    getEmployerRefInfo: build.query<EmployerRefInfoResponse, void>({
      query() {
        const boardId = getBoardId();
        return {
          url: `v1/employers/${boardId}/info`,
          method: 'GET',
          headers: COMMON_HEADERS,
        };
      },
      transformResponse(response: { data: EmployerRefInfoResponse }) {
        return response.data;
      },
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, tokens['EMPLOYER_REFERENCE_NOT_FOUND']);
      },
      providesTags: ['EMPLOYER_REF_INFO'],
    }),
    updateEmployerRefInfo: build.mutation<void, UpdateEmployerRefInfoRequestType>({
      query({ requestBody }) {
        const boardId = getBoardId();
        return {
          url: `v1/employers/${boardId}/info`,
          method: 'POST',
          body: {
            ...requestBody,
          },
          headers: COMMON_HEADERS,
        };
      },
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, employerRefTokens['ERROR']);
      },
      invalidatesTags: ['EMPLOYER_REF_INFO', 'PROVINCIAL_LEVIES', 'LOCAL_LEVIES'],
    }),
  }),
  overrideExisting: false,
});

export { employerRefApi };
